// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notif-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 1.5rem;
  z-index: 9999;
  pointer-events: none;
}

/* Center the notification vertically and horizontally */
.notif-centered {
  align-items: center;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
}

.notif-container {
  max-width: 28rem;
  width: 100%;
  background: #ffffff;
  border-radius: 0.75rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  pointer-events: auto;
  transform: translateY(0);
  opacity: 1;
  animation: notifFadeIn 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  border-top: 4px solid #4CAF50;
  position: relative;
}

/* Make the notification larger */
.notif-larger {
  max-width: 32rem;
  transform: scale(1.1);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

.notif-container.hidden {
  transform: translateY(-12px);
  opacity: 0;
  transition: all 0.5s ease-out;
}

.notif-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4CAF50, #8BC34A, #4CAF50);
  background-size: 200% 100%;
  animation: notifGradientMove 3s ease infinite;
}

.notif-inner {
  padding: 1.5rem;
  position: relative;
}

.notif-content {
  display: flex;
  align-items: flex-start;
}

.notif-icon-wrapper {
  flex-shrink: 0;
}

.notif-success-circle {
  height: 4rem;
  width: 4rem;
  border-radius: 50%;
  background-color: rgba(76, 175, 80, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}

.notif-icon-container {
  transition: all 0.7s ease;
}

.notif-icon-container.hidden {
  opacity: 0;
  transform: scale(0.5);
}

.notif-icon-container.visible {
  opacity: 1;
  transform: scale(1);
}

.notif-check-icon {
  color: #4CAF50;
}

.notif-text-container {
  margin-left: 1.5rem;
  flex: 1 1;
  min-width: 0;
  padding-top: 0.125rem;
}

.notif-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333333;
  margin: 0;
  transition: all 0.5s ease;
}

.notif-title.hidden {
  opacity: 0;
}

.notif-title.visible {
  opacity: 1;
}

.notif-message {
  margin-top: 0.75rem;
  font-size: 1rem;
  color: #666666;
  line-height: 1.5;
  transition: all 0.5s ease;
  transition-delay: 0.3s;
}

.notif-message.hidden {
  opacity: 0;
}

.notif-message.visible {
  opacity: 1;
}

.notif-button-container {
  margin-top: 1.5rem;
  transition: all 0.5s ease;
  transition-delay: 0.7s;
  display: flex;
  justify-content: center;
}

.notif-button-container.hidden {
  opacity: 0;
}

.notif-button-container.visible {
  opacity: 1;
}

.notif-home-button {
  display: inline-flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.notif-home-button:hover {
  background-color: #1976D2;
  transform: translateY(-2px);
}

.notif-home-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.3);
}

.notif-home-button:active {
  background-color: #0D47A1;
  transform: translateY(0);
}

.notif-home-icon {
  margin-right: 0.5rem;
}

.notif-close-button {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background: transparent;
  border: none;
  color: #9E9E9E;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0.25rem;
  z-index: 10;
}

.notif-close-button:hover {
  color: #616161;
  transform: rotate(90deg);
}

.notif-close-button:focus {
  outline: none;
}

/* Progress bar for auto-dismiss functionality */
.notif-progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background-color: rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.notif-progress-inner {
  height: 100%;
  width: 0;
  background-color: #4CAF50;
  animation: notifProgress 8s linear forwards;
}

/* Animations with prefixed names to avoid conflicts */
@keyframes notifFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes notifPulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes notifGradientMove {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes notifProgress {
  0% { width: 0%; }
  100% { width: 100%; }
}

/* Checkmark animation */
.animate-checkmark {
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  animation: notifCheckmark 0.8s ease-in-out forwards;
}

.animate-circle {
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  animation: notifCircle 1s ease-in-out 0.2s forwards;
}

.animate-bounce-x {
  animation: notifBounceX 1.5s infinite;
}

@keyframes notifCheckmark {
  from {
    stroke-dashoffset: 100;
  }
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes notifCircle {
  from {
    stroke-dashoffset: 100;
    stroke-dasharray: 100;
  }
  to {
    stroke-dashoffset: 0;
    stroke-dasharray: 100;
  }
}

@keyframes notifBounceX {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(4px);
  }
}

/* Optional: Button hover glow effect */
.hover-glow:hover {
  box-shadow: 0 0 15px rgba(59, 130, 246, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/Pages/ApplicationForm/NotifSubmit.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,UAAU;EACV,kEAAkE;EAClE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,SAAO;EACP,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA,sDAAsD;AACtD;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,KAAK,SAAS,EAAE;EAChB,OAAO,WAAW,EAAE;AACtB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,uCAAuC;AACvC;EACE,4CAA4C;AAC9C","sourcesContent":[".notif-wrapper {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  padding: 1.5rem;\r\n  z-index: 9999;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Center the notification vertically and horizontally */\r\n.notif-centered {\r\n  align-items: center;\r\n  height: 100vh;\r\n  background-color: rgba(0, 0, 0, 0.4);\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.notif-container {\r\n  max-width: 28rem;\r\n  width: 100%;\r\n  background: #ffffff;\r\n  border-radius: 0.75rem;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\r\n  overflow: hidden;\r\n  pointer-events: auto;\r\n  transform: translateY(0);\r\n  opacity: 1;\r\n  animation: notifFadeIn 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;\r\n  border-top: 4px solid #4CAF50;\r\n  position: relative;\r\n}\r\n\r\n/* Make the notification larger */\r\n.notif-larger {\r\n  max-width: 32rem;\r\n  transform: scale(1.1);\r\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.notif-container.hidden {\r\n  transform: translateY(-12px);\r\n  opacity: 0;\r\n  transition: all 0.5s ease-out;\r\n}\r\n\r\n.notif-container::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 4px;\r\n  background: linear-gradient(90deg, #4CAF50, #8BC34A, #4CAF50);\r\n  background-size: 200% 100%;\r\n  animation: notifGradientMove 3s ease infinite;\r\n}\r\n\r\n.notif-inner {\r\n  padding: 1.5rem;\r\n  position: relative;\r\n}\r\n\r\n.notif-content {\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n\r\n.notif-icon-wrapper {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.notif-success-circle {\r\n  height: 4rem;\r\n  width: 4rem;\r\n  border-radius: 50%;\r\n  background-color: rgba(76, 175, 80, 0.15);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.notif-icon-container {\r\n  transition: all 0.7s ease;\r\n}\r\n\r\n.notif-icon-container.hidden {\r\n  opacity: 0;\r\n  transform: scale(0.5);\r\n}\r\n\r\n.notif-icon-container.visible {\r\n  opacity: 1;\r\n  transform: scale(1);\r\n}\r\n\r\n.notif-check-icon {\r\n  color: #4CAF50;\r\n}\r\n\r\n.notif-text-container {\r\n  margin-left: 1.5rem;\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding-top: 0.125rem;\r\n}\r\n\r\n.notif-title {\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  color: #333333;\r\n  margin: 0;\r\n  transition: all 0.5s ease;\r\n}\r\n\r\n.notif-title.hidden {\r\n  opacity: 0;\r\n}\r\n\r\n.notif-title.visible {\r\n  opacity: 1;\r\n}\r\n\r\n.notif-message {\r\n  margin-top: 0.75rem;\r\n  font-size: 1rem;\r\n  color: #666666;\r\n  line-height: 1.5;\r\n  transition: all 0.5s ease;\r\n  transition-delay: 0.3s;\r\n}\r\n\r\n.notif-message.hidden {\r\n  opacity: 0;\r\n}\r\n\r\n.notif-message.visible {\r\n  opacity: 1;\r\n}\r\n\r\n.notif-button-container {\r\n  margin-top: 1.5rem;\r\n  transition: all 0.5s ease;\r\n  transition-delay: 0.7s;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.notif-button-container.hidden {\r\n  opacity: 0;\r\n}\r\n\r\n.notif-button-container.visible {\r\n  opacity: 1;\r\n}\r\n\r\n.notif-home-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0.75rem 1.5rem;\r\n  background-color: #2196F3;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 0.375rem;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.notif-home-button:hover {\r\n  background-color: #1976D2;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.notif-home-button:focus {\r\n  outline: none;\r\n  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.3);\r\n}\r\n\r\n.notif-home-button:active {\r\n  background-color: #0D47A1;\r\n  transform: translateY(0);\r\n}\r\n\r\n.notif-home-icon {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.notif-close-button {\r\n  position: absolute;\r\n  top: 0.75rem;\r\n  right: 0.75rem;\r\n  background: transparent;\r\n  border: none;\r\n  color: #9E9E9E;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  padding: 0.25rem;\r\n  z-index: 10;\r\n}\r\n\r\n.notif-close-button:hover {\r\n  color: #616161;\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.notif-close-button:focus {\r\n  outline: none;\r\n}\r\n\r\n/* Progress bar for auto-dismiss functionality */\r\n.notif-progress-bar {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 4px;\r\n  background-color: rgba(0, 0, 0, 0.05);\r\n  overflow: hidden;\r\n}\r\n\r\n.notif-progress-inner {\r\n  height: 100%;\r\n  width: 0;\r\n  background-color: #4CAF50;\r\n  animation: notifProgress 8s linear forwards;\r\n}\r\n\r\n/* Animations with prefixed names to avoid conflicts */\r\n@keyframes notifFadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.9);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes notifPulse {\r\n  0% {\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    transform: scale(1.15);\r\n  }\r\n  100% {\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes notifGradientMove {\r\n  0% {\r\n    background-position: 0% 50%;\r\n  }\r\n  50% {\r\n    background-position: 100% 50%;\r\n  }\r\n  100% {\r\n    background-position: 0% 50%;\r\n  }\r\n}\r\n\r\n@keyframes notifProgress {\r\n  0% { width: 0%; }\r\n  100% { width: 100%; }\r\n}\r\n\r\n/* Checkmark animation */\r\n.animate-checkmark {\r\n  stroke-dasharray: 100;\r\n  stroke-dashoffset: 100;\r\n  animation: notifCheckmark 0.8s ease-in-out forwards;\r\n}\r\n\r\n.animate-circle {\r\n  stroke-dasharray: 100;\r\n  stroke-dashoffset: 100;\r\n  animation: notifCircle 1s ease-in-out 0.2s forwards;\r\n}\r\n\r\n.animate-bounce-x {\r\n  animation: notifBounceX 1.5s infinite;\r\n}\r\n\r\n@keyframes notifCheckmark {\r\n  from {\r\n    stroke-dashoffset: 100;\r\n  }\r\n  to {\r\n    stroke-dashoffset: 0;\r\n  }\r\n}\r\n\r\n@keyframes notifCircle {\r\n  from {\r\n    stroke-dashoffset: 100;\r\n    stroke-dasharray: 100;\r\n  }\r\n  to {\r\n    stroke-dashoffset: 0;\r\n    stroke-dasharray: 100;\r\n  }\r\n}\r\n\r\n@keyframes notifBounceX {\r\n  0%, 100% {\r\n    transform: translateX(0);\r\n  }\r\n  50% {\r\n    transform: translateX(4px);\r\n  }\r\n}\r\n\r\n/* Optional: Button hover glow effect */\r\n.hover-glow:hover {\r\n  box-shadow: 0 0 15px rgba(59, 130, 246, 0.5);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
